module.exports = __webpack_public_path__ + "static/media/checked.ff1fe30f.svg";